import { Banner } from "@custom-types/BannerModel";
import { SET_BANNERS } from "@store/actions/banners.actions";
import { RELOAD } from "@store/actions/global";

interface state {
    banners: Array<Banner>;
}

const initialState: state = {
    banners: [],
};

const bannersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BANNERS:
            return {
                ...state,
                banners: [...action.banners],
            };

        case RELOAD:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};

export default bannersReducer;
